export const LOCAL_STORAGE_KEYS = {
	TOKEN: "token",
	CURRENT_USER: "currentUser",
};